module.exports = __webpack_public_path__ + "img/avbi06e.0cb91462.png";